<template>
  <div class="table-with-filters">
    <div
      v-if="$slots['filters']"
      class="table-with-filters__filters mb-20 mb-28--l"
    >
      <slot name="filters" />
    </div>

    <div
      v-if="$slots['controll-mobile']"
      class="table-with-filters__controll-mobile mb-20"
    >
      <slot name="controll-mobile" />
    </div>

    <div class="table-with-filters__content">
      <template v-if="!fetching">
        <slot
          name="table"
        />
      </template>

      <div v-else class="txt--main">
        <exc-loader height="14" />
      </div>

      <div
        v-if="showLoadMore"
        class="table-with-filters__more-section pt-20 pb-32--l pb-20 flx flx--content-center"
      >
        <exc-button
          :loading="loading"
          class="table-with-filters__load-more"
          size="s"
          @click="$emit('loadMore')"
        >
          <span class="txt--12px txt--white">
            {{ $t('history.moreButton') }}
          </span>
        </exc-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ExcLoader, ExcButton } from '@/components/common'

export default {
  name: 'TableWithFiltersNew',
  components: {
    ExcButton,
    ExcLoader,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    showLoadMore: {
      type: Boolean,
      default: true,
    },
    loading: { // for load more
      type: Boolean,
      default: true,
    },
    fetching: { // for list first fetching
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.table-with-filters {

  &__filters {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    z-index: 2;

    @include bp(sm) {
      flex-direction: row;
    }

    @include bp(l) {
      justify-content: flex-start;
    }
  }

  &__content {
    position: relative;
    z-index: 1;
  }

  &__load-more {
    min-width: toRem(160px);
  }

  &__controll-mobile {
    @include bp(m) {
      display: none;
    }
  }
}
</style>
